export default __webpack_public_path__ + "static/cube-579c249ba063d251ac50f11020ff371f.png";